import React, { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Header from "../../components/appLayout/header";
import SEO from "../../components/SEO";
import "./index.scss";

import img from "../../assets/images/loca.svg";
import img1 from "../../assets/images/phone.svg";
import img2 from "../../assets/images/email.png";
import img3 from "../../assets/images/facebook.svg";
import img4 from "../../assets/images/intaa.png";
import img5 from "../../assets/images/linn.png";
import { API_URL } from "../../config/config";

export default function ContactSection() {
  const { t } = useTranslation();
  const [formValues, setFormValues] = useState({
    fullname: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API_URL}contacts`, formValues);
      toast.success(t("contact1.successMessage"));
      console.log("✅ Données envoyées :", res.data);
      setFormValues({
        fullname: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      console.error("❌ Erreur lors de l’envoi :", error);
      toast.error(t("contact1.errorMessage"));
    }
  };

  return (
    <>
      <SEO
        title="Contactez MSIT Conseil - Nous Contacter"
        description="Contactez MSIT Conseil pour vos projets de transformation digitale. Notre équipe d'experts est à votre disposition pour répondre à vos besoins en conseil, IA, data et services technologiques."
        keywords="contact MSIT, contacter MSIT conseil, formulaire contact, MSIT conseil contact"
        url="https://www.msit-conseil.fr/contact"
        breadcrumbs={[
          { name: "Accueil", url: "https://www.msit-conseil.fr/" },
          { name: "Contact", url: "https://www.msit-conseil.fr/contact" }
        ]}
      />
      <Header />
      <section className="contact-section">
        <div className="content-contact">
          <div className="contact-title">
            <h2 className="title mt-3">{t("contact1.title")}</h2>
            <p className="subtitle">{t("contact1.subtitle")}</p>
          </div>

          <Row className="contact-content ms-0">
            {/* Informations */}
            <Col md={4} className="contact-info">
              <h5>{t("contact1.infoTitle")}</h5>
              <ul className="info-list">
                <li className="d-flex align-items-center">
                  <img src={img} alt="localisation" />
                  <div>
                    <h6>{t("contact1.addressTitle")}</h6>
                    <p>{t("contact1.addressText")}</p>
                  </div>
                </li>
                <li className="d-flex align-items-center">
                  <img src={img1} alt="téléphone" />
                  <div>
                    <h6>{t("contact1.phoneTitle")}</h6>
                    <p>{t("contact1.phoneText")}</p>
                  </div>
                </li>
                <li className="d-flex align-items-center">
                  <img src={img2} alt="email" />
                  <div>
                    <h6>Email</h6>
                    <p>{t("contact1.emailText")}</p>
                  </div>
                </li>
              </ul>

              <div className="socials">
                <span>{t("contact1.followUs")}</span>
                <div className="icons">
                  <a href="https://www.facebook.com/MSITConseil">
                    <img src={img3} alt="facebook" />
                  </a>
                  <a href="https://www.instagram.com/msit.conseil/">
                    <img src={img4} alt="instagram" />
                  </a>
                  <a
                    href="https://tn.linkedin.com/company/msit-conseil
">
                    <img src={img5} alt="linkedIn" />
                  </a>
                </div>
              </div>
            </Col>

            {/* Formulaire */}
            <Col md={8} className="ps-0 ps-md-3 pe-0 pe-md-3 pt-3 pt-md-0">
              <Form className="contact-form" onSubmit={onSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>{t("contact1.form.name")}</Form.Label>
                      <Form.Control
                        type="text"
                        name="fullname"
                        placeholder={t("contact1.form.namePlaceholder")}
                        value={formValues.fullname}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder={t("contact1.form.emailPlaceholder")}
                        value={formValues.email}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label>{t("contact1.form.subject")}</Form.Label>
                  <Form.Control
                    type="text"
                    name="subject"
                    placeholder={t("contact1.form.subjectPlaceholder")}
                    value={formValues.subject}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>{t("contact1.form.message")}</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="message"
                    placeholder={t("contact1.form.messagePlaceholder")}
                    value={formValues.message}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Button type="submit" className="btn-send">
                  {t("contact1.form.send")}
                </Button>
              </Form>
            </Col>
          </Row>

          {/* Carte */}
          <div className="map-container mt-4">
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10470.341305210135!2d2.037623526079469!3d48.99944831933528!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e68ae101836ecb%3A0x6ef7c16d12737ef!2s78780%20Maurecourt%2C%20France!5e0!3m2!1sen!2stn!4v1762329038834!5m2!1sen!2stn"
              allowFullScreen
              loading="lazy"></iframe>
          </div>
        </div>
      </section>
    </>
  );
}
